import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./parallex1.css";

const testimonials = [
  {
    name: "Mahesh Chavda",
    description:
      "Horizon Webinfo Pvt Ltd helped us implement and customize Odoo ERP exactly as per our business process. Their Odoo ERP developers understood Indian accounting, inventory, and GST requirements very well. The system has improved our efficiency and reporting.",
  },
  {
    name: "Nitin Mohitra - Dynamics Machine Pvt Ltd",
    description:
      "We approached Horizon Webinfo for custom software development, and they delivered a solution that matched our workflow perfectly. The software is user-friendly, scalable, and has reduced our manual work significantly. Highly recommended IT company in India.",
  },
  {
    name: "Rajesh Kothra",
    description:
     "Our website was developed by Horizon Webinfo, and we are very satisfied with the design, speed, and SEO structure. The team created a professional and mobile-friendly website that generates regular enquiries for our business.",
  },
  {
    name: "Kirtan Solanki - Magix Software",
    description:
     "Horizon Webinfo automated our internal business processes, saving us time and reducing errors. Their automation solution helped us manage operations smoothly and improved overall productivity. A reliable technology partner for Indian businesses.",
  },
  {
    name: "Dharamraj - Dharamraj Construction Pvt Ltd",
    description:
     "We are using Horizon Webinfo’s cloud server and hosting services for our ERP and website. The server performance, security, and uptime are excellent. Their support team is responsive and always available when needed.",
  },
  {
    name: "Hardik Shah",
    description:
     "Horizon Webinfo developed our e-commerce website with payment gateway integration and inventory management. The platform is fast, secure, and easy to manage. Our online sales have improved after launching the new website.",
  },
  {
    name: "Mukund Sharma",
    description:
      "We have taken domain registration, hosting, and business email services from Horizon Webinfo. Everything is managed smoothly under one roof, and their support is prompt. It gives our business a professional identity.",
  },
  {
    name: "Kaushik Raj",
    description:
      "We have been working with Horizon Webinfo Pvt Ltd for ongoing IT support and maintenance. Their team is dependable, transparent, and understands business priorities. A trusted IT service provider in Ahmedabad.",
  },
];

const ParallaxSection = ({backgroundImage1 }) => {
  return (
    <div
      className="parallax-section"
      style={{ backgroundImage: `url(${backgroundImage1})` }}
    >
      <div className="parallax-content">
        <div className="white-box1">
          {/* Button and Title (Fixed, not part of Swiper) */}
          <button className="testimonials-btn">Testimonials</button>
          <h2 className="clients-title">Clients Reviews</h2>

          {/* Swiper Slider */}
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 4000 }}
            loop={true}
            className="testimonials-swiper"
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial-card">
                  <p className="testimonial-text">“{item.description}”</p>
                  <h4 className="testimonial-name">{item.name}</h4>
                  <p className="testimonial-role">{item.designation}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default ParallaxSection;
